export default {"src":"/uk/_next/static/media/spot-icons-60px.830dbf70.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};